import axios from '~/utils/axios';
import { HeadTransaction } from '~/types/HeadTransaction';
import { Amount } from '~/types';

interface AccountRef {
  accountNumber?: string;
  accountId?: string;
}

interface ReferenceEntry {
  id: string;
  value: string;
}

export interface CreateConsentRequest {
  sender: AccountRef;
  recipient: AccountRef;
  operationSubtype: string;
  amount: Amount;
  note?: string;
  referenceId?: ReferenceEntry[];
  additionalProperties?: Record<string, unknown>;
}

export const createConsent = (request: CreateConsentRequest) => {
  const url = `/debitOrder/consent`;
  return axios.post<HeadTransaction>(url, request);
};

interface CreateTransactionProps {
  consentId: string;
}

export const createTransaction = ({ consentId }: CreateTransactionProps) => {
  const url = `/debitOrder`;
  return axios.post<HeadTransaction>(url, { consentId });
};
